import { http } from '../../utils';
const controller = 'master-data/employees';
export const getEmployees = async (page, pageSize, orderBy, departmentId, userName, sequenceStatus, searchCondition, isResigned, isSeasonal) => await http.get(controller, {
    params: {
        departmentId,
        isResigned,
        searchCondition,
        userName,
        sequenceStatus,
        page,
        pageSize,
        orderBy,
        isSeasonal
    }
});
export const getEmployeesByDepartment = async (departmentId, searchCondition, sequenceEmployeeIdExclude) => {
    return await http.get(`${controller}/fullInfo`, {
        params: {
            departmentId,
            searchCondition,
            sequenceEmployeeIdExclude
        }
    });
};
export const getEmployeesDropdown = async (departmentId, searchCondition, sequenceEmployeeIdExclude, hasUserName) => {
    return await http.get(`${controller}/dropdown`, {
        params: {
            departmentId,
            searchCondition,
            sequenceEmployeeIdExclude,
            hasUserName
        }
    });
};
export const getDriversDropdown = async (dateCheck) => {
    return await http.get(`${controller}/drivers-short`, {
        params: { dateCheck }
    });
};
export const getEmployeeShortsDropdown = async (departmentId, searchCondition, sequenceEmployeeIdExclude) => {
    return await http.get(`${controller}/employee-short`, {
        params: {
            departmentId,
            searchCondition,
            sequenceEmployeeIdExclude
        }
    });
};
export const getShortEmployeesDropdown = async (departmentId, searchCondition, sequenceEmployeeIdExclude) => {
    return await http.get(`${controller}/employee-short`, {
        params: {
            departmentId,
            searchCondition,
            sequenceEmployeeIdExclude
        }
    });
};
export const getEmployeesExport = async (departmentId, isSeasonal) => {
    return await http.get(`${controller}/export`, {
        params: { departmentId, isSeasonal },
        responseType: 'blob'
    });
};
export const getEmployeeReport = async (departmentId) => {
    return await http.get(`${controller}/report`, {
        params: { departmentId }
    });
};
export const getEmployeUsersDropdown = async (searchCondition, sequenceEmployeeIdExclude) => {
    return await http.get(`${controller}/employee-user-by-condition`, {
        params: {
            searchCondition,
            sequenceEmployeeIdExclude
        }
    });
};
export const getEmployeesDropdownByDepartments = async (lstDepartmentId) => {
    return await http.get(`${controller}/dropdown-by-departments`, {
        params: {
            lstDepartmentId
        }
    });
};
export const getUsernamesByDepartmentDropdown = async (departmentId) => {
    return await http.get(`${controller}/get-username-by-department`, {
        params: {
            departmentId
        }
    });
};
export const getEmployeesDropdownByWithLaborType = async () => {
    return await http.get(`${controller}/employee-include-labor-type`);
};
export const getEmployee = async (id) => await http.get(`${controller}/${id}`);
export const addEmployee = async (employee) => {
    return await http.post(controller, employee);
};
export const updateEmployee = async (id, employee) => {
    return await http.put(`${controller}/${id}`, employee);
};
export const deleteEmployee = async (id) => await http.delete(`${controller}/${id}`);
